export default __webpack_public_path__ + "static/media/wallart8.c71be16b.jpg";